import { render, staticRenderFns } from "./FilterSourcesStats.vue?vue&type=template&id=8fd11ef8&scoped=true"
import script from "./FilterSourcesStats.vue?vue&type=script&lang=js"
export * from "./FilterSourcesStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd11ef8",
  null
  
)

export default component.exports